import { useEffect, useState } from 'react';
import useTranslation from './useTranslation';
import { convertPersianDigitsToEnglishDigits } from 'utils/text';

const useForm = (validate, callback, initialValues) => {
  const [values, setValues] = useState({ ...initialValues });
  const [errors, setErrors] = useState({ ...initialValues });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { getAppLocale } = useTranslation('COMMON');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((values) => ({
      ...values,
      [name]: value,
    }));
  };

  const handleChangePhoneNumber = (event) => {
    const { name, value } = event.target;
    setValues((values) => ({
      ...values,
      [name]: convertPersianDigitsToEnglishDigits(value),
    }));
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback(values);
    } else {
      setIsSubmitting(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  const emailValidation = (email) => {
    const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;

    if (regEx.test(email)) {
      return 'Email is Valid';
    }

    if (!regEx.test(email) && email !== '') {
      return 'Email is Not Valid';
    }

    return;
  };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(values, getAppLocale()));
    setIsSubmitting(true);
  };

  const resetForm = () => {
    setValues({ ...initialValues });
    setErrors({ ...initialValues });
    setIsSubmitting(false);
  };

  const setDefaultValues = (values) => {
    setValues({ ...values });
    setErrors({ ...initialValues });
  };

  const phoneNumberValidation = (phoneNumber) => {
    const regEx = /^\d{10}$/;

    if (regEx.test(phoneNumber)) {
      return 'Phone number is valid';
    }

    if (!regEx.test(phoneNumber) && phoneNumber !== '') {
      return 'Phone number is not valid';
    }
  };

  return {
    values,
    errors,
    handleChange,
    handleSubmit,
    resetForm,
    setDefaultValues,
    emailValidation,
    phoneNumberValidation,
    handleChangePhoneNumber,
  };
};

export default useForm;
